<template>
  <section class="hero-section" :class="{ 'is-active': isActive }">
    <!-- 배경 이미지 (전체) -->
    <div class="hero-bg">
      <img src="@/assets/hero/hero.jpg" alt="" class="hero-image" />
      <!-- 대각선 그라데이션 오버레이 -->
      <div class="hero-gradient"></div>
    </div>

    <!-- 우측 텍스트 콘텐츠 -->
    <div class="hero-content">
      <div class="right-content">
        <!-- 장식 점 -->
        <div class="deco-dots">
          <span class="dot dot-sm"></span>
          <span class="dot dot-lg"></span>
        </div>

        <!-- 메인 카피 -->
        <div class="main-copy">
          <p class="copy-sub">프리미엄 라이프의 중심</p>
          <h2 class="copy-main">새로운 기준이 되다</h2>
        </div>

        <!-- 구분선 -->
        <div class="divider-line"></div>

        <!-- 브랜드 로고 -->
        <div class="brand-area">
          <img src="@/assets/logo/logo_text.png" alt="청주 레이원시티 홍보관 상담센터" class="brand-logo" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection',
  props: {
    isActive: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>
.hero-section {
  height: 100vh;
  position: relative;
  overflow: hidden;
}

/* 배경 이미지 - 전체 영역 */
.hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.hero-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: left center;
  display: block;
}

/* 대각선 그라데이션 오버레이 */
.hero-gradient {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    115deg,
    transparent 0%,
    transparent 35%,
    rgba(255, 255, 255, 0.3) 45%,
    rgba(255, 255, 255, 0.85) 55%,
    #fff 65%
  );
}

/* 우측 텍스트 영역 */
.hero-content {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.right-content {
  text-align: center;
  padding: 40px;
  width: 45%;
}

/* 장식 점 */
.deco-dots {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  margin-bottom: 48px;
  opacity: 0;
  transform: translateY(15px);
  transition: all 0.6s ease;
}

.hero-section.is-active .deco-dots {
  opacity: 1;
  transform: translateY(0);
  transition-delay: 0.2s;
}

.dot {
  border-radius: 50%;
  background: var(--rayone-primary);
}

.dot-sm {
  width: 6px;
  height: 6px;
  opacity: 0.5;
}

.dot-lg {
  width: 10px;
  height: 10px;
}

/* 메인 카피 */
.main-copy {
  margin-bottom: 32px;
}

.copy-sub {
  font-family: var(--font-pretendard);
  font-size: 22px;
  font-weight: 300;
  color: #333;
  letter-spacing: 2px;
  margin-bottom: 8px;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.7s cubic-bezier(0.16, 1, 0.3, 1);
}

.hero-section.is-active .copy-sub {
  opacity: 1;
  transform: translateY(0);
  transition-delay: 0.3s;
}

.copy-main {
  font-family: var(--font-pretendard);
  font-size: 52px;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: 3px;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.7s cubic-bezier(0.16, 1, 0.3, 1);
}

.hero-section.is-active .copy-main {
  opacity: 1;
  transform: translateY(0);
  transition-delay: 0.4s;
}

/* 구분선 */
.divider-line {
  width: 1px;
  height: 60px;
  background: #ccc;
  margin: 0 auto 48px;
  opacity: 0;
  transform: scaleY(0);
  transform-origin: top;
  transition: all 0.6s ease;
}

.hero-section.is-active .divider-line {
  opacity: 1;
  transform: scaleY(1);
  transition-delay: 0.6s;
}

/* 브랜드 로고 */
.brand-area {
  opacity: 0;
  transform: translateY(15px);
  transition: all 0.7s ease;
}

.hero-section.is-active .brand-area {
  opacity: 1;
  transform: translateY(0);
  transition-delay: 0.7s;
}

.brand-logo {
  height: 80px;
  width: auto;
  object-fit: contain;
}

/* 반응형 */
@media (max-width: 1200px) {
  .right-content {
    width: 50%;
  }

  .copy-main {
    font-size: 40px;
  }

  .copy-sub {
    font-size: 18px;
  }

  .brand-logo {
    height: 60px;
  }
}

@media (max-width: 900px) {
  .hero-gradient {
    background: linear-gradient(
      to bottom,
      transparent 0%,
      transparent 30%,
      rgba(255, 255, 255, 0.5) 45%,
      rgba(255, 255, 255, 0.9) 55%,
      #fff 65%
    );
  }

  .hero-content {
    align-items: flex-end;
    justify-content: center;
  }

  .right-content {
    width: 100%;
    padding: 24px 24px 60px;
  }

  .deco-dots {
    margin-bottom: 24px;
  }

  .copy-sub {
    font-size: 16px;
  }

  .copy-main {
    font-size: 32px;
  }

  .main-copy {
    margin-bottom: 20px;
  }

  .divider-line {
    height: 40px;
    margin-bottom: 24px;
  }

  .brand-logo {
    height: 50px;
  }
}
</style>
